import React, { useEffect, useState } from 'react';
import { ContainerBtn  } from '../../styles';
import { LitButton } from '../../../shared/LitButton';
import { gateway } from '../../../../utils/api';
import { checkIsVertibular } from '../../../../utils/functions';

function VestibularButtons({ loading, goToAssessment, code, data }) {

    const initialState = data.status && data.status === "Iniciado";
    const [enabled, setEnabled] = useState(initialState);

    useEffect(() => {
        function checkVestibularWorkFlow() {
            try {
                const isVestibular = checkIsVertibular();
                if (isVestibular) {
                    const intervalId = setInterval(async () => {
                    try {
                        const idProfile = localStorage.getItem('idProfile');
                        const statusData = await gateway.get(`/response/response/status/${idProfile}/${code}`);
                        const statusVestibular = statusData.status === 'STARTED';
                        setEnabled(statusVestibular);
                    } catch (error) {
                        console.error("Erro ao requisitar endpoint:", error);
                    }
                    }, 5000);

                    return () => clearInterval(intervalId);
                }
            } catch (error) {
                console.error("checkVestibularWorkFlow", error);
            }
        }
        checkVestibularWorkFlow();
    }, []);

    return (
        <ContainerBtn>
            <LitButton
                disabled={!enabled || loading}
                style={{
                    textTransform: 'uppercase',
                    fontFamily: 'Dosis',
                    paddingLeft: 20,
                    paddingRight: 20,
                    fontSize: 20,
                }}
                onClick={goToAssessment}
                className={`${loading && ' btn-loading'}`}
            >
                <i className='fa fa-send' /> INICIAR
            </LitButton>
        </ContainerBtn>
    );
}

export default VestibularButtons;